export default "/packs/images/Greer~de32da1dc4c8e95c1f3a8539420511e8.jpg";